import React from 'react';

export default function ToastAnnouncer() {
  return (
    <div aria-live="polite" aria-atomic="true" className="sr-only"></div>
  );
}
